import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function Interest({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/InterestFactors");
    };

    const goPrev = () => {
        navigate("/SavingsDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Interest
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Interest is the amount of money you pay to borrow money and is usually an 
                </div>
                <div className="text-[#000000] text-3xl">
                    annual rate.  In banking, this is the amount of money your savings account will 
                </div>
                <div className="text-[#000000] text-3xl">
                    receive when it matures.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    There are 3 types of interest:  simple, compound, and accrued.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Simple interest is interest calculated based on the original amount of money 
                </div>
                <div className="text-[#000000] text-3xl">
                    that is owed.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Compound interest is interest calculated based on the original amount of 
                </div>
                <div className="text-[#000000] text-3xl">
                    money owed and interest gathered over time (“interest on interest”).
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    Accrued interest is simply accumulated interest and does not have a fixed date 
                </div>
                <div className="text-[#000000] text-3xl">
                    on payment (but must be paid back).
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}